<template>
    <div>
        <v-expansion-panels v-model="panel" mandatory>

            <div class="w-100">
                <v-alert type="error" text class="" border="right" colored-border
                         v-if="vtcMaxProvidersCount === vtc.providers_count + selectedProvidersComputed.length">
                    Vous avez atteints la limite de prestataires que vous pouvez suivre. Vous ne pouvez
                    plus en ajouter tant que vous n'en avez pas retirer de la veille.
                </v-alert>
            </div>

            <v-expansion-panel v-if="notAlreadyInVtc.length">
                <v-expansion-panel-header>
                    <div class="table-title">
                        <h3>Prestataires à suivre
                            <div class="badge bg-success text-white">{{
                                    selectedProvidersComputed.length
                                }}
                            </div>
                        </h3>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-simple-table fixed-header height="50vh" class="elevation-1">
                        <thead>
                        <tr>
                            <!-- Checkbox select-all -->
                            <th>
                                <v-checkbox
                                  :input-value="allSelectableSelected"
                                  :indeterminate="someSelectableSelected && !allSelectableSelected"
                                  :disabled="selectableItems.length === 0"
                                  @change="selectAllToggle"
                                />
                            </th>
                            <th>Nom</th>
                            <th>Catégorie</th>
                            <th>Commune</th>
                            <th>Destinataire</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in notAlreadyInVtc" :key="returnItemKey(item)">
                            <!-- Checkbox ligne -->
                            <td>
                                <v-checkbox
                                  :input-value="returnInputValue(item)"
                                  :disabled="checkboxIsDisabled(item)"
                                  @change="handleCheck(item)"
                                />
                            </td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.category }}</td>
                            <td>{{ item.commune }}</td>
                            <td>{{ item.email }}</td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel v-if="alreadyInVtc.length">
                <v-expansion-panel-header>
                    <div class="table-title">
                        <h3>Prestataires ignorés (déjà suivis)
                            <div class="badge bg-success text-white">{{
                                    alreadyInVtc.length
                                }}
                            </div>
                        </h3>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-simple-table class="border" fixed-header height="50vh">
                        <thead>
                        <tr>
                            <th class="text-left">Nom</th>
                            <th class="text-left">Catégorie</th>
                            <th class="text-left">Destinataire</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="provider in alreadyInVtc" :key="provider.id">
                            <td>{{ provider.name }}</td>
                            <td>{{ provider.category }}</td>
                            <td>
                                                <span v-if="provider.email !== null">
                                                    {{ provider.email }}
                                                </span>
                            </td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div class="text-right mb-5 mt-5">
            <v-btn v-if="notAlreadyInVtc.length" class="default-button"
                   @click="setAddProStep(parseInt(addProStep) + 1)">Passer à l'étape suivante
            </v-btn>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import * as EmailValidator from "email-validator"

export default {
    name: "VtcProvidersSelection",
    data() {
        return {
            panel: [0],
            headers: [
                {
                    text: "Nom",
                    value: "name",
                },
                {
                    text: "Catégorie",
                    value: "category",
                },
                {
                    text: "Commune",
                    value: "commune",
                },
                {
                    text: "Destinataire",
                    value: "email",
                },
            ],
        }
    },
    methods: {
        ...mapMutations("vtc", [
            "setAddProStep",
            "setEmailsValid",
            "setEmailsWrong",
            "setProvidersToAdd",
            "setNoEmails",
        ]),
        setEmailLists() {
            let emailsValid = []
            let emailsWrong = []
            let noEmails = []

            this.providersToAdd.forEach(provider => {
                if (provider.email === null) {
                    provider.error = "Email non renseigné"
                    noEmails.push(provider)
                } else if (!EmailValidator.validate(provider.email)) {
                    provider.error = "Mauvais format d'email"
                    emailsWrong.push(provider)
                } else {
                    emailsValid.push(provider)
                }
            })

            this.setEmailsValid(emailsValid)
            this.setEmailsWrong(emailsWrong)
            this.setNoEmails(noEmails)
        },
        handleCheck(item) {
            const current = [...this.selectedProvidersComputed]

            if(this.selectedApidaeSelection) {
                const exists = current.some(p => p.external_id === item.external_id)

                if (exists) {
                    this.selectedProvidersComputed = current.filter(p => p.external_id !== item.external_id)
                } else if (current.length + this.vtc.providers_count < this.vtcMaxProvidersCount) {
                    this.selectedProvidersComputed = current.concat(item)
                }
            } else {
                const exists = current.some(p => p.id === item.id)

                if (exists) {
                    this.selectedProvidersComputed = current.filter(p => p.id !== item.id)
                } else if (current.length + this.vtc.providers_count < this.vtcMaxProvidersCount) {
                    this.selectedProvidersComputed = current.concat(item)
                }
            }
        },
        selectAllToggle(isChecked) {
            let current = [...this.selectedProvidersComputed]

            if (isChecked) {
                const remaining = this.vtcMaxProvidersCount - (this.vtc.providers_count + current.length)
                if (remaining <= 0) return

                let toAdd

                if(this.selectedApidaeSelection) {
                    toAdd = this.notAlreadyInVtc
                      .filter(p => !current.some(c => c.external_id === p.external_id))
                      .slice(0, remaining)
                } else {
                   toAdd = this.notAlreadyInVtc
                      .filter(p => !current.some(c => c.id === p.id))
                      .slice(0, remaining)
                }

                current = current.concat(toAdd)
            } else {
                current = []
            }

            this.selectedProvidersComputed = current
        },
        returnInputValue(item) {
            if(this.selectedApidaeSelection) {
                return this.selectedProvidersComputed.some(p => p.external_id === item.external_id)
            } else {
                return this.selectedProvidersComputed.some(p => p.id === item.id)
            }
        },
        checkboxIsDisabled(item) {
            if(this.selectedApidaeSelection) {
                return this.vtc.providers_count + this.selectedProvidersComputed.length >= this.vtcMaxProvidersCount &&
                  !this.selectedProvidersComputed.some(p => p.external_id === item.external_id)
            } else {
                return this.vtc.providers_count + this.selectedProvidersComputed.length >= this.vtcMaxProvidersCount &&
                  !this.selectedProvidersComputed.some(p => p.id === item.id)
            }
        },
        returnItemKey(item) {
            if(this.selectedApidaeSelection) {
                return item.id
            } else {
                return item.external_id
            }
        }
    }
    ,
    computed: {
        ...
          mapState("vtc", [
              "emailsValid",
              "emailsWrong",
              "addProStep",
              "notAlreadyInVtc",
              "selectedApidaeSelection",
              "providersToAdd",
              "alreadyInVtc",
              "vtc",
              "vtcMaxProvidersCount",
              "selectedApidaeSelection",
          ]),
        selectableItems() {
            const alreadySelected = this.selectedProvidersComputed
            const remaining = this.vtcMaxProvidersCount - this.vtc.providers_count
            let notSelected

            if(this.selectedApidaeSelection) {
                notSelected = this.notAlreadyInVtc.filter(item =>
                  !alreadySelected.some(p => p.external_id === item.external_id)
                )
            } else {
                notSelected = this.notAlreadyInVtc.filter(item =>
                  !alreadySelected.some(p => p.id === item.id)
                )
            }

            return alreadySelected.concat(notSelected.slice(0, remaining))
        },
        allSelectableSelected() {
            const selectable = this.selectableItems
            if(this.selectedApidaeSelection) {
                return selectable.length > 0 &&
                  selectable.every(item => this.selectedProvidersComputed.some(p => p.external_id === item.external_id))
            } else {
                return selectable.length > 0 &&
                  selectable.every(item => this.selectedProvidersComputed.some(p => p.id === item.id))
            }
        },
        someSelectableSelected() {
            const selectable = this.selectableItems
            if(this.selectedApidaeSelection) {
                return selectable.some(item => this.selectedProvidersComputed.some(p => p.external_id === item.external_id))
            } else {
                return selectable.some(item => this.selectedProvidersComputed.some(p => p.id === item.id))
            }
        },
        selectedProvidersComputed: {
            get() {
                return this.$store.state.vtc.selectedProviders
            },
            set(value) {
                this.$store.commit("vtc/setSelectedProviders", value)
                this.setProvidersToAdd(value)
                this.setEmailLists()
            },
        },
    },
}
</script>
